import useStore from '../store/auth'

const usePrimaryLicense = () => {
  const primaryLicense = useStore((state) => state.primaryLicense)
  const primaryRole = useStore((state) => state.primaryRole)
  const populatePrimaryLicense = useStore((state) => state.populatePrimaryLicense)
  const setPrimaryLicense = useStore((state) => state.setPrimaryLicense)

  return [primaryLicense, primaryRole, populatePrimaryLicense, setPrimaryLicense] as const
}

export default usePrimaryLicense
